'use client';
import SmallArrow from '@/assets/svg/SmallArrow';
import { Locale } from '@/enums/locale.enum';
import { cn } from '@/lib/utils';
import { Direction } from '@/types/direction';
import Image from 'next/image';
import Link from 'next/link';

interface Props {
  data: Direction;
  index: number;
  lang?: string;
}

export default function Service({ data, index, lang }: Props) {
  return (
    <div
      className={cn(
        'grid grid-cols-12 2xl:pr-[160px] pl-[90px] pr-[90px] lg:grid-cols-5 border-b border-black/50 py-14 sm:py-4 ',
        'sm:flex lg:gap-8 sm:flex-col md:flex md:flex-col md:gap-6 sm:gap-10 sm:px-2 lg:px-4 md:px-4 gap-24 min-h-52',
        {
          'border-t': index === 0,
        }
      )}
      key={data.color}
      id={data.name.toLowerCase().replaceAll(' ', '-')}
    >
      <div className='col-span-4 sm:hidden'>
        <Image
          src={data.img.url}
          width={data.img.width}
          height={data.img.height}
          className='2xl:w-[449px] 2xl:h-[439px] w-[300px] h-[294px] object-cover sm:w-[344px] sm:h-[255px] rounded-[10px]'
          alt=''
          unoptimized
          onContextMenu={(e) => e.preventDefault()}
        />
      </div>
      <div className='col-span-5 flex flex-col gap-6'>
        <div className='flex gap-4 lg:col-span-2'>
          <div
            className='2xl:w-6 2xl:h-6 w-3 h-3 sm:w-3 sm:h-3  mt-0.5 rounded-full'
            style={{
              backgroundColor: data.color,
            }}
          />
          <div className='2xl:text-[30px] text-[20px] sm:text-[16.88px] 2xl:w-[240px] w-[170px]  leading-none tracking-normal uppercase  font-bold'>
            {data.name.split('\\n')[0].toUpperCase()}
            <br />
            {data.name.split('\\n')[1]?.toUpperCase()}
          </div>
        </div>
        <div className='sm:hidden 2xl:w-full w-[412px] '>
          <p className='sm:text-[13px]  2xl:text-[16px] text-[12px] leading-[131%] font-normal font-poppins'>
            {data.description}
          </p>
        </div>
      </div>
      <div className='hidden sm:block col-span-4'>
        <Image
          src={data.img.url}
          width={data.img.width}
          height={data.img.height}
          className='w-full h-[439px] object-cover sm:w-[344px] sm:h-[255px]'
          alt=''
          unoptimized
          onContextMenu={(e) => e.preventDefault()}
        />
      </div>
      <div className='mt-[65px] w-[350px] 2xl:w-[410px] flex flex-col gap-2 sm:mt-0 col-span-3'>
        {data.services.map((i) => (
          <Link key={i.id} href={`/services/${i.slug}`}>
            <p className='2xl:text-[19.5px] text-[13px] sm:font-normal leading-[100%] font-bold tracking-[-0.03em] uppercase sm:text-[14.27px]'>
              {i.name.toUpperCase()}
              <span className='inline-block ml-2 2xl:w-3 2xl:h-3  w-2 h-2 sm:h-[9px] sm:w-[10px]'>
                <SmallArrow className='fill-black' />
              </span>
            </p>
          </Link>
        ))}
        {/* if it's ophir industrial */}
        {data.name.toLowerCase() === 'ophir industrial' && (
          <Link key={17} href={`/services/vr-training-and-simulation`}>
            <p className='2xl:text-[19.5px] text-[13px] sm:font-normal leading-[100%] font-bold tracking-[-0.03em] uppercase sm:text-[14.27px]'>
              {lang == Locale.IT ? 'SIMULAZIONI E TRAINING IN REALTÀ VIRTUALE' : 'VR Training and Simulation'}
              <span className='inline-block ml-2 2xl:w-3 2xl:h-3  w-2 h-2 sm:h-[9px] sm:w-[10px]'>
                <SmallArrow className='fill-black' />
              </span>
            </p>
          </Link>
        )}
      </div>
      <div className='hidden sm:block'>
        <p className='sm:text-[13px] text-[16px] leading-[131%] font-normal font-poppins'>
          {data.description}
        </p>
      </div>
    </div>
  );
}
